import { SavingState } from '@common/Common';
import CorporateNavigation from "@common/Components/CorporateNavigation.vue";
import SaveButton from '@common/Components/SaveButton.vue';
import { guid } from '@common/Guid';
import { ICommandBase } from '@Quest/cqrs';
import { CreatePnlCommandV1 } from '@Quest/Pnls/Domain/commands-core';
import PnlsCommands from '@Quest/Pnls/Domain/commands-vue-component';
import PnlsQueries from '@Quest/Pnls/Domain/queries-vue-component';
import { CorporatePnlTemplateReadModel } from '@Quest/Pnls/Domain/readmodels';
import Component, { mixins } from 'vue-class-component';


@Component({ components: { CorporateNavigation, SaveButton } })
export default class PnlCreatePage extends mixins(PnlsCommands, PnlsQueries)
{
    get workspaceId(): number { return Number.parseInt(this.$route.params.workspaceId); }
    get strategyId() { return this.$route.params.strategyId; }
    get templateId(): string | null { return this.$route.params.templateId ?? null; }

    rm: CorporatePnlTemplateReadModel | null = null;

    savingState: SavingState = SavingState.Pending;

    mounted()
    {
        document.title = "Create P&L | TransparentChoice";

        if (this.templateId)
        {
            this.runDefaultPnlTemplateByIdQueryV1(this.workspaceId, this.strategyId, this.templateId);
        }
        else
        {
            this.rm = new CorporatePnlTemplateReadModel();
        }
    }

    handleCreatePnlCommand()
    {
        if (this.rm)
        {
            this.savingState = SavingState.InProgress;
            this.invokeCreatePnlCommandV1(this.workspaceId, this.strategyId, guid(), this.rm.Name, this.rm.StartYear, this.rm.StartMonth, this.rm.Columns);
        }
    }

    onSetModel(model: any, modelName: string)
    {
        if (modelName === "CorporatePnlTemplateReadModel")
        {
            this.rm = model as CorporatePnlTemplateReadModel;
        }
    }

    onCommandSucceed(cmd: ICommandBase, correlationId: string)
    {
        if (CreatePnlCommandV1.matchType(cmd))
        {
            alert('created');
            this.$router.push({ path: `/enterprise/pnls/edit/${this.workspaceId}/${this.strategyId}/${correlationId}` });
        }
    }
}